// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__qB0s2","footer":"ReportModalFilter_footer__2q-7h"};